export const getQuestions = (state) => state.topQuestions.questions;

export const getCountryLanguageCode = (state) => state.topQuestions.countryLanguageCode;

export const getUserId = (state) => state.topQuestions.userId;

export const getPreliminaryFilter = (state) => state.topPreliminary.filter;

